import { create } from 'zustand';

type Severity = 'error' | 'warning' | 'success' | 'info';

interface NotificationState {
  title: string | null;
  message: string | null;
  severity: Severity;
  show: (message: string, severity?: Severity, title?: string) => void;
  clear: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  title: null,
  message: null,
  severity: 'error',
  show: (message, severity = 'error', title) => set({ message, severity, title: title ?? null }),
  clear: () => set({ message: null, title: null }),
}));
